import { DATE_FORMATS } from 'constants/dateFormats';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

// Initialize the plugin for parsing non-ISO strings like 'MM/DD/YYYY'
dayjs.extend(customParseFormat);

export const formatCommentDate = ({ date }) => {
  if (!date) return '';
  return dayjs(date).format(DATE_FORMATS.COMMENT);
};

export const formatStandardDate = ({ date }) => {
  if (!date) return 'N/A';
  return dayjs(date).format(DATE_FORMATS.STANDARD);
};

export const formatMediumDate = ({ date }) => {
  return date ? dayjs(date).format(DATE_FORMATS.MEDIUM) : '';
};

export const formatDayDate = ({ date }) => {
  return date ? dayjs(date).format(DATE_FORMATS.DAY) : '';
};

export const formatCustomDate = ({ date }) => {
  return date ? dayjs(date).format(DATE_FORMATS.CUSTOM) : '';
};

export const formatShortDate = ({ date, format = DATE_FORMATS.SHORT }) => {
  return date ? dayjs(date).format(format) : 'N/A';
};

export const parseShortDateString = ({ date }) => {
  // Returns the parsed dayjs object, or null if no string was provided
  return date ? dayjs(date, DATE_FORMATS.SHORT) : null;
};

export const formatActiveDate = ({ date }) => {
  return date ? dayjs(date).format(DATE_FORMATS.ACTIVE) : '';
};

export const isPastDue = ({ date }) => {
  // If there is no due date, it technically can't be overdue
  return date ? dayjs().isAfter(date) : false;
};

export const parseDate = ({ date }) => {
  // Returns a dayjs object if the date exists, otherwise returns null
  // to prevent accidental current-date generation (which dayjs() does by default)
  return date ? dayjs(date) : null;
};

export const formatRelativeTime = ({ date }) => {
  return date ? dayjs(date).fromNow() : '';
};

export const convertDaysToMilliseconds = ({ days }) => {
  return days * 24 * 60 * 60 * 1000;
};
